import { ItemChartModel } from '../global/item-chart.model';

export class SuspensionChartModel {
  total: number = 0;
  states: ItemChartModel[] = [];
}
